import { useCallback, useEffect, useState } from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BreadCrumb, SnackSimple } from '../../../../../../components'
import { Types } from '../../../../../../utils/enums'
import { ObjectGeneric, onChange } from '../../../../../../utils/types/generals'
import { initialData, initialValues } from './../main/initialState'
import Form from '../../components/optionDefault'
import { useContextState } from '../../../../../../hooks/theme'
import { httpFetch } from '../../../../../../utils/crud'
import { OptionGroupService } from '../../../../../../service/optionGroup'
import { OptionGroupList } from '../../../../../../service/optionGroup/reponse'
import SimpleModal from '../../../../../../components/modal/simpleModal'
import { useNavigate, useParams } from 'react-router-dom'
import { useStyles } from './style'
import { handleErrors, submit } from '../methods/methods'
import { TemplateType } from '../../enums'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { InputModel } from '../../../../../../utils/types'
import ListOptionGroup from '../../components/optionList'
import { LoadingButton } from '@mui/lab'
import Loader from '../../../../../../components/loader'
import CatalogOption from '../../components/catalogOption'
import { useCatalogStore } from '../../components/catalogOption/context'
import { createOptionDropDownBody } from '../../../../../../service/optionGroup/body'
import { formatOptiongById } from '../../../../../../service/optionGroup/format'


const OptionGroupForm = () => {

    const navigate = useNavigate()
    const { t } = useTranslation()
    const { colors } = useContextState()
    const styles = useStyles(colors)
    const { id } = useParams()
    const [mainInput, setMainInput] = useState<{ [x: string]: InputModel; }>(initialValues)
    const [allErrors, setAllErrors] = useState<ObjectGeneric>({})
    const [data, setData] = useState<ObjectGeneric>(initialData)
    const [options, setOptions] = useState<{ description: string; icon: File | null | string, id: number }[]>([])
    const [exernalData, setExternalData] = useState<ObjectGeneric>({})
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void,
        butonNext: string
        butonCancel: string,
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { },
        butonNext: t('general.confirm'),
        butonCancel: t('general.cancel')
    })

    const [btnLoading, setBtnLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { items, setSubCatalog, catalogRoot, setItems, setCatalogRoot } = useCatalogStore();

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        openModal: false,
        message: '',
        type: Types.SUCCESS,
    })

    const handleCloseSnackbar = (value: boolean) => {
        setOpenSnackbar((prev) => ({ ...prev, open: value }))
    }

    const mainChange: onChange = (e, id): void => {
        const { name, value } = e?.target
        let body = { ...data }

        body = {
            ...body,
            [name]: value,
        }

        setData(body)
        setAllErrors(handleErrors(body, t))
    }

    const addOption = useCallback((item: { description: string; icon: File | null, id: number }, id?: number) => {
        setOptions(prevOptions => {
            if (!id) {
                return [...prevOptions, item];
            } else {
                return prevOptions.map(opt =>
                    opt.id === id ? { ...opt, ...item } : opt
                );
            }
        });
        setExternalData({})
    }, []);

    const deleteOption = useCallback((id: number) => {
        setOptions(prevOptions => prevOptions.filter(opt => opt.id !== id));
    }, []);

    const editOption = useCallback((item: { description: string; icon: File | null | string, id: number }) => {
        setExternalData({ description: item.description, iconUrl: item.icon, id: item.id });
    }, []);

    const handleSubmit = async (forced?:boolean) => {
        setBtnLoading(true)
        const dropList = createOptionDropDownBody({ items })
        const response = await submit({ force:forced, dropLinks: dropList.drop_downs_links, template: data.template, title: data.title, options: data.template == TemplateType.DEFAULT ? options : undefined, t, id: id ? Number(id) : null })

        if (!response?.response?.response.errors) {
            setTimeout(() => {
                navigate('../')
            }, 3000)
        }

        setOptions(response.response.copyOptions ?? [])
        setOpenSnackbar(() => ({ ...response.snackbarBody }))
        setModal(prev => ({
            ...prev,
            open: response.snackbarBody.openModal,
            butonNext: t('general.yes'),
            butonCancel: t('general.no'),
            title: response.snackbarBody.message,
            description: '',
            confirm: () => {
                handleSubmit(true)
                closeModal()
            }
        }))
        setBtnLoading(false)
    }

    const handleCancel = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            butonNext: t('general.confirm'),
            butonCancel: t('general.cancel'),
            title: t('optionGroup.modal.cancel.title'),
            description: t('optionGroup.modal.cancel.description'),
            confirm: () => {
                navigate('../')
                closeModal()
            }
        }))
    }

    const getItem = async (id: number) => {
        setIsLoading(true)

        const response: OptionGroupList = await OptionGroupService(httpFetch).getOptionGroupById(id)

        setData(prev => ({
            ...prev,
            template: response.typeOptionGroupId,
            title: response.title
        }))

        setMainInput(prev => {
            const { template, ...rest } = prev;

            return {
                ...rest,
                title: {
                    ...rest.title,
                    size: {
                        xl: 12, lg: 12, md: 12, sm: 12, xs: 12,
                    },
                },
            };
        });

        if (!response?.errors) {
            if (response.typeOptionGroupId == TemplateType.DEFAULT) {
                setOptions(
                    response.options?.map((item, index) => ({
                        description: item.description,
                        icon: item.iconUrl,
                        id: index + 1,
                    })) ?? []
                )
            } else {
                //Items
                const format = formatOptiongById({response});
                if(response.dropDownLinks[0].parent){
                    setCatalogRoot(response.dropDownLinks[0].parent.id)
                }
                setItems(format.items)
            }

        }
        setIsLoading(false)
    }

    const getTypesOption = async () => {
        setIsLoading(true)
        const response = await OptionGroupService(httpFetch).getOptionType()

        if (!response?.errors) {
            setMainInput(prev => ({
                ...prev,
                template: {
                    ...prev.template,
                    items: response.map((item, index) => ({
                        label: item.name,
                        value: item.id,
                    })) ?? []
                }
            }));
        }
        setIsLoading(false)
    }

    const getCatalog = async () => {

        const response = await OptionGroupService(httpFetch).getAllDropList();

        const catalogs = !response.errors
            ? response?.map((catalog) => {
                return {
                    label: catalog.name,
                    value: catalog.id,
                    children: catalog.children
                }
            })
            : []

        setSubCatalog(catalogs)
    }

    const handleDisabled = () => data.title && ((data.template == TemplateType.DEFAULT && options.length > 1) || (data.template == TemplateType.CATALOG && items.length > 1))

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    useEffect(() => {
        setItems([])
        setCatalogRoot(undefined)
        if (id) {
            getItem(Number(id))
        } else {
            getTypesOption()
        }
    }, [id])

    useEffect(() => {
        getCatalog()
    }, [])

    return (<>
        {isLoading ? <Loader /> :
            <Box sx={styles.container}>
                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} time={3000} />

                <BreadCrumb
                    removeBreadcrumb={['setting']}
                    replaceLabels={{ 'option-group': 'settingOptionGroup', 'form': 'createOptionGroup', 'formEdit': 'editOptionGroup' }}
                />

                <Box sx={styles.containerBody}>
                    <Grid container>
                        <Grid item xs={data.template == TemplateType.DEFAULT ? 6 : 12} sm={data.template == TemplateType.DEFAULT ? 6 : 12} md={data.template == TemplateType.DEFAULT ? 7 : 12} lg={7} xl={7} sx={styles.gridLeft(data.template == TemplateType.DEFAULT)} >
                            <Typography variant="title_grey_big">{t(`optionGroup.title.${id ? 'editOption' : 'newOption'}`)}</Typography>

                            <Box sx={styles.containerForm}>
                                <DinamicForm spacing={{ column: 3, row: 3 }} input={Object.values(mainInput)} values={data} onChange={mainChange} errors={allErrors} legacyErrors />
                            </Box>

                            {data.template == TemplateType.DEFAULT &&
                                <Form
                                    color={colors}
                                    addOption={addOption}
                                    externalData={exernalData}
                                />
                            }
                        </Grid>
                        {data.template == TemplateType.DEFAULT &&
                            <Grid item xs={6} sm={6} md={5} lg={5} xl={5} sx={styles.gridRight}>
                                <Typography variant="title_grey_big">{t('optionGroup.title.optionsAdded')}</Typography>

                                <ListOptionGroup options={options} deleteOption={deleteOption} editOption={editOption} />
                            </Grid>
                        }
                    </Grid>

                    {data.template == TemplateType.CATALOG &&
                        <CatalogOption id="1" children={items} level={1} depth={1} subCatalogId={catalogRoot} />
                    }
                </Box>

                <Box sx={styles.buttonsContainer}>
                    <Button onClick={() => { handleCancel() }}>
                        {t('optionGroup.buttons.cancel')}
                    </Button>
                    <LoadingButton loading={btnLoading} disabled={!handleDisabled()} className="next" variant="contained" onClick={() => { handleSubmit() }}>
                        {t('optionGroup.buttons.' + (id ? 'editGroup' : 'addGroup'))}
                    </LoadingButton>
                </Box>

                <SimpleModal
                    open={!!modal.open}
                    next={modal.confirm}
                    back={closeModal}
                    close={closeModal}
                    description={modal.description}
                    buttonText={modal.butonNext}
                    cancelText={modal.butonCancel}
                    title={modal.title}
                    loadingButton
                    isLoading={btnLoading}
                />


            </Box>
        }
    </>
    )
}

export default OptionGroupForm
